import api from "./api";
import { fetchTraderProductList, groupTraderProductsIntoCategories } from "./products";

export async function fetchPrices(memberRoleId) {
  // Use trader product list API
  try {
    const products = await fetchTraderProductList();
    return groupTraderProductsIntoCategories(products);
  } catch (error) {
    console.error("Error fetching trader prices:", error);
    // Fallback to original API if trader API fails
    const params = memberRoleId ? { memberRoleId } : {};
    const res = await api.get("/prices", { params });
    return res.data;
  }
}

export async function updatePrice({ categoryId, itemId, premium, spread }) {
  await api.put("/prices", { categoryId, itemId, premium, spread });
}

// Role-based price management
export async function getRoleProductPrices(memberRoleId) {
  const res = await api.get(`/prices/roles/${memberRoleId}`);
  return res.data;
}

export async function updateRoleProductPrice(memberRoleId, { productId, premium, spread, startTime, endTime, buyEnabled, sellEnabled }) {
  const res = await api.put(`/prices/roles/${memberRoleId}`, { productId, premium, spread, startTime, endTime, buyEnabled, sellEnabled });
  return res.data;
}

export async function deleteRoleProductPrice(memberRoleId, productId) {
  await api.delete(`/prices/roles/${memberRoleId}/products/${productId}`);
}

export async function backfillRolePrices(memberRoleId) {
  const res = await api.post(`/prices/roles/${memberRoleId}/backfill`);
  return res.data;
}


